import { ChangeDetectorRef, Component, ElementRef, HostListener, ViewEncapsulation, inject } from '@angular/core';
import { Observable, BehaviorSubject, combineLatest, map } from 'rxjs';
import { UserService } from '../../../../shared/services/config/user.service';
import { TokenStorage } from '../../../../shared/services/config/tokenStorage.service';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { FilterService } from '../../../../shared/components/filters/services/filters.service';
import { Empresa } from '../../../Cadastro/empresa/model/empresa.model';
import { EmpresaService } from '../../../Cadastro/empresa/services/empresa.service';
import { PermissionsService } from '../../../../shared/services/config/permissions.service';
import { AuthService } from '../../../../auth/auth.service';

@Component({
  standalone: true,
  selector: 'app-empresa-dropdown',
  imports: [CommonModule, ReactiveFormsModule, FormsModule, TranslateModule],
  templateUrl: './empresa-dropdown.component.html',
  styleUrls: ['./empresa-dropdown.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EmpresaDropdownComponent {
  private readonly _empresaService = inject(EmpresaService);
  private readonly _userService = inject(UserService);
  private readonly _tokenStorage = inject(TokenStorage);
  private readonly userPermissionService = inject(PermissionsService);
  private readonly _authService = inject(AuthService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly router = inject(Router);
  private readonly _dashboardService = inject(FilterService);
  private readonly eRef = inject(ElementRef);

  empresas$: Observable<Empresa[]> = new Observable<Empresa[]>();
  empresaControl = new FormControl<number | null>(null);
  empresaLogadaId: number = 0;
  usuarioEmpresas: any;

  showDropdown = false;
  inputValue = '';
  selectedItem: Empresa | null = null;

  userIsAdmin: boolean = false;

  private searchTerm$ = new BehaviorSubject<string>('');
  filteredOptions: Empresa[] = [];

  async ngOnInit(): Promise<void> {
    this.userPermissionService.isAdmin().then(isAdmin => {
      this.userIsAdmin = isAdmin;
    });
    this.empresas$ = this._empresaService.get();
    this.usuarioEmpresas = this._userService.getUsuarioEmpresaLogado();
    this.empresas$ = await this._empresaService.get().pipe(
      map(todasEmpresas => {
        if (this.userIsAdmin) {
          return todasEmpresas;
        } else {
          return todasEmpresas.filter(x =>
            this.usuarioEmpresas.some((u: any) => u.empresaId === x.id)
          );
        }
      })
    );

    this.empresaLogadaId = this._userService.getEmpresaLogada();
    this.cdr.detectChanges();

    combineLatest([this.empresas$, this.searchTerm$])
      .pipe(
        map(([empresas, search]) => {
          // Se não houver pesquisa, mostra tudo
          const filtradas = empresas.filter(e =>
            e.nomeFantasia.toLowerCase().includes(search.toLowerCase())
          );

          // Se houver empresa salva, seta o selectedItem uma vez
          if (this.empresaLogadaId > 0 && !this.selectedItem) {
            const empresaSalva = empresas.find(e => e.id === this.empresaLogadaId);
            if (empresaSalva) {
              this.selectedItem = empresaSalva;
              this.empresaControl.setValue(empresaSalva.id, { emitEvent: false });
            }
          } 

          return filtradas;
        })
      )
      .subscribe(filtered => {
        this.filteredOptions = filtered;
        this.cdr.detectChanges();
      });

    // Quando o formControl mudar, atualiza o userService
    this.empresaControl.valueChanges.subscribe(id => {
      if (id) this.empresaChange({ id });
    });
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.showDropdown = false;
    }
  }


  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
    if (this.showDropdown) this.searchTerm$.next('');
  }

  onSearchChange(search: string) {
    this.searchTerm$.next(search);
  }

  selectItem(empresa: Empresa) {
    this.selectedItem = empresa;
    this.empresaControl.setValue(empresa.id);
    this.showDropdown = false;
    this.inputValue = '';
  }

  async empresaChange(event: any) {
    const empresaIdArmazenada = this.obterEmpresaIdStorage();
    this._authService.trocarEmpresa(event.id).subscribe(data => {
      if (!event) {
        this.empresaLogadaId = 0;
        this._userService.setEmpresaId('');
      } else {
        this.empresaLogadaId = event.id;
        this._userService.setEmpresaId(`${event.id}`);
        this._dashboardService.atualizarEmpresaId(event.id);
      }
      if (!event || empresaIdArmazenada !== event.id) {
        window.location.reload();
      }
    });
  }

  obterEmpresaIdStorage() {
    const empresaId = this._userService.getEmpresaId();
    return empresaId ? parseInt(empresaId) : 0;
  }

  removeSelected() {
    this._authService.trocarEmpresa(0).subscribe({
      next: () => {
        this.selectedItem = null;
        this.empresaControl.setValue(null);
        this._userService.setEmpresaId('');
        this.empresaLogadaId = 0;
        this.inputValue = '';
        this._dashboardService.atualizarEmpresaId(0);
        window.location.reload();
      },
      error: (err) => {
        console.error('Erro ao remover empresa selecionada', err);
      }
    });
    // this.reloadRoute();
  }
}
